import React from 'react';
import './ProductShowcase.css';
import productImage1 from '../assets/IMG_0860.JPG';
import productImage2 from '../assets/poloImage.jpeg';
import productImage3 from '../assets/IMG_6962.jpg';
import productImage4 from '../assets/IMG_2332.jpg';
import productImage5 from '../assets/IMG_2345.jpg';
import productImage6 from '../assets/IMG_2710.jpg';
import productImage7 from '../assets/IMG_4489.jpg'

const products = [
  {
    id: 1,
    name: 'Custom T-Shirt',
    description: 'High-quality custom printed shirt.',
    price: 'From £11.00',
    image: productImage5,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  },
  {
    id: 2,
    name: 'Custom Polo',
    description: 'Premium quality custom polo.',
    price: 'From £16.00',
    image: productImage2,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  },
  {
    id: 3,
    name: 'Custom Gilet',
    description: 'Professional custom gilet.',
    price: '£35.00',
    image: productImage7,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  },
  {
    id: 4,
    name: 'Hoodies',
    description: 'Premium custom hoodie.',
    price: '£26.00',
    image: productImage1,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  },
  {
    id: 5,
    name: 'Softshell jackets',
    description: 'Premium Softshell jacket',
    price: '£36.00',
    image: productImage6,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  },
  {
    id: 6,
    name: 'Hats',
    description: 'Quality baseball cap or wool hat',
    price: '£15.00',
    image: productImage3,
    imageAlt: 'Custom printed product view',
    category: 'Apparel',
    available: true,
  }
];

const ProductShowcase = () => {
  return (
    <div className="product-showcase">
      <h2>Our Products</h2>
      <div className="product-grid">
        {products.map((product) => (
          <div className="product-card" key={product.id}>
            <img src={product.image} alt={product.name} className="product-image" />
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <p className="product-price">{product.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductShowcase;
